var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTaskChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.804 0h10.404C21.276 0 24 2.856 24 7.104v9.805C24 21.144 21.276 24 17.208 24H6.804C2.736 24 0 21.144 0 16.91V7.103C0 2.856 2.736 0 6.804 0zm4.512 15.588l5.7-5.7a1.057 1.057 0 000-1.488 1.057 1.057 0 00-1.488 0l-4.956 4.956-2.1-2.1a1.057 1.057 0 00-1.488 0 1.057 1.057 0 000 1.488l2.856 2.844c.204.204.468.3.732.3.276 0 .54-.096.744-.3z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconTaskChecked;